<div class="bg-green-500/5 border border-green-500/20 rounded-xl p-4 space-y-4">
  <h3 class="text-sm font-semibold text-white flex items-center gap-2">
    <span class="material-symbols-outlined text-base text-green-400">add_card</span>
    {{ 'pos.tabs.add_payment' | translate }}
  </h3>

  @if (data().canPayWithPoints && data().hasAnyBalance) {
    <div class="grid grid-cols-2 gap-3">
      <button
        type="button"
        data-testid="tab-payment-type-money"
        (click)="selectPaymentType(PaymentType.Money)"
        class="p-3 rounded-xl border-2 transition-all flex items-center justify-center gap-2"
        [class.border-neon]="selectedPaymentType() === PaymentType.Money"
        [class.bg-neon/10]="selectedPaymentType() === PaymentType.Money"
        [class.border-white/10]="selectedPaymentType() !== PaymentType.Money"
        [class.bg-white/5]="selectedPaymentType() !== PaymentType.Money">
        <span
          class="material-symbols-outlined text-xl"
          [class.text-neon]="selectedPaymentType() === PaymentType.Money">
          euro
        </span>
        <span class="font-semibold text-sm">{{ 'pos.tabs.money' | translate }}</span>
      </button>

      <button
        type="button"
        data-testid="tab-payment-type-points"
        (click)="selectPaymentType(PaymentType.Points)"
        class="p-3 rounded-xl border-2 transition-all flex items-center justify-center gap-2"
        [class.border-amber-500]="selectedPaymentType() === PaymentType.Points"
        [class.bg-amber-500/10]="selectedPaymentType() === PaymentType.Points"
        [class.border-white/10]="selectedPaymentType() !== PaymentType.Points"
        [class.bg-white/5]="selectedPaymentType() !== PaymentType.Points">
        <span
          class="material-symbols-outlined text-xl"
          [class.text-amber-400]="selectedPaymentType() === PaymentType.Points">
          star
        </span>
        <span class="font-semibold text-sm">{{ 'pos.tabs.points' | translate }}</span>
      </button>
    </div>
  }

  @if (selectedPaymentType() === PaymentType.Money) {
    <div>
      <label class="block text-xs text-white/50 mb-2">{{ 'pos.tabs.payment_amount' | translate }}</label>
      <div class="relative">
        <input
          type="number"
          step="0.01"
          min="0.01"
          data-testid="tab-payment-amount"
          [ngModel]="paymentAmount()"
          (ngModelChange)="paymentAmount.set($event)"
          class="w-full bg-transparent border border-white rounded-full py-3 px-4 pr-12 text-white text-lg font-bold focus:outline-none focus:border-green-500 transition-all" />
        <span class="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 font-medium">€</span>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <button
        type="button"
        data-testid="tab-payment-method-cash"
        (click)="selectPaymentMethod(PaymentMethod.Cash)"
        class="p-3 rounded-xl border-2 transition-all flex items-center justify-center gap-2"
        [class.border-green-500]="selectedPaymentMethod() === PaymentMethod.Cash"
        [class.bg-green-500/10]="selectedPaymentMethod() === PaymentMethod.Cash"
        [class.border-white/10]="selectedPaymentMethod() !== PaymentMethod.Cash"
        [class.bg-white/5]="selectedPaymentMethod() !== PaymentMethod.Cash">
        <span
          class="material-symbols-outlined text-xl"
          [class.text-green-400]="selectedPaymentMethod() === PaymentMethod.Cash">
          payments
        </span>
        <span class="font-semibold text-sm">{{ 'pos.checkout.cash' | translate }}</span>
      </button>

      <button
        type="button"
        data-testid="tab-payment-method-card"
        (click)="selectPaymentMethod(PaymentMethod.Card)"
        class="p-3 rounded-xl border-2 transition-all flex items-center justify-center gap-2"
        [class.border-green-500]="selectedPaymentMethod() === PaymentMethod.Card"
        [class.bg-green-500/10]="selectedPaymentMethod() === PaymentMethod.Card"
        [class.border-white/10]="selectedPaymentMethod() !== PaymentMethod.Card"
        [class.bg-white/5]="selectedPaymentMethod() !== PaymentMethod.Card">
        <span
          class="material-symbols-outlined text-xl"
          [class.text-green-400]="selectedPaymentMethod() === PaymentMethod.Card">
          credit_card
        </span>
        <span class="font-semibold text-sm">{{ 'pos.checkout.card' | translate }}</span>
      </button>
    </div>

    @if (selectedPaymentMethod() === PaymentMethod.Card && qrCodeDataUrl()) {
      <div class="bg-white/5 rounded-xl p-4">
        <div class="flex flex-col items-center gap-3">
          <p class="text-sm text-white/70 text-center">{{ 'pos.checkout.scan_qr_for_payment' | translate }}</p>
          <div
            class="bg-white rounded-xl p-2"
            data-testid="qr-code-container">
            <img
              [src]="qrCodeDataUrl()"
              alt="QR Code"
              class="w-48 h-48"
              data-testid="qr-code-image" />
          </div>
          <div class="text-center">
            <p class="text-xs text-white/50 mb-1">{{ 'pos.checkout.iban' | translate }}</p>
            <p class="text-sm font-mono text-white select-all">{{ PAYMENT_IBAN }}</p>
          </div>
          @if (currentVariableSymbol()) {
            <div class="text-center">
              <p class="text-xs text-white/50 mb-1">{{ 'pos.checkout.variable_symbol' | translate }}</p>
              <p
                class="text-sm font-mono text-white select-all"
                data-testid="variable-symbol"
                >{{ currentVariableSymbol() }}</p
              >
            </div>
          }
          <p class="text-lg font-bold text-neon">{{ paymentAmount() | number: '1.2-2' }} €</p>
        </div>
      </div>
    }
  } @else {
    <div class="space-y-3">
      <div class="flex items-center justify-between">
        <label class="text-xs text-white/50">{{ 'pos.tabs.select_items_to_pay' | translate }}</label>
        <div class="flex gap-2">
          <button
            type="button"
            data-testid="tab-points-select-all"
            (click)="selectAllItems()"
            class="text-xs text-amber-400 hover:text-amber-300 transition-colors">
            {{ 'pos.tabs.select_all' | translate }}
          </button>
          <span class="text-white/20">|</span>
          <button
            type="button"
            (click)="deselectAllItems()"
            class="text-xs text-white/50 hover:text-white/70 transition-colors">
            {{ 'pos.tabs.deselect_all' | translate }}
          </button>
        </div>
      </div>

      <div class="bg-white/5 rounded-xl overflow-hidden max-h-[250px] overflow-y-auto">
        @for (item of unpaidItemsWithPoints(); track item.productId) {
          <div
            class="px-4 py-3 border-b border-white/5 last:border-b-0 transition-colors"
            data-testid="tab-points-item"
            [attr.data-product-name]="item.name"
            [class.bg-amber-500/10]="getSelectedQty(item.productId) > 0">
            <div class="flex items-center justify-between gap-3 mb-2">
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-white truncate">{{ item.name }}</p>
                <p class="text-xs text-white/50">
                  {{ item.unitPoints }} b. / ks · {{ 'pos.tabs.max' | translate }}: {{ item.pointsEligibleQty }}
                </p>
              </div>
              <span class="text-sm font-bold text-amber-400 shrink-0">
                {{ getSelectedQty(item.productId) * item.unitPoints }} b.
              </span>
            </div>
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <button
                  type="button"
                  (click)="decrementSelectedQty(item.productId)"
                  [disabled]="getSelectedQty(item.productId) === 0"
                  class="w-8 h-8 rounded-full bg-white/10 text-white hover:bg-white/20 disabled:opacity-30 disabled:cursor-not-allowed transition-colors flex items-center justify-center">
                  <span class="material-symbols-outlined text-lg">remove</span>
                </button>
                <span class="w-10 text-center font-bold text-white text-lg">{{ getSelectedQty(item.productId) }}</span>
                <button
                  type="button"
                  (click)="incrementSelectedQty(item.productId)"
                  [disabled]="getSelectedQty(item.productId) >= item.pointsEligibleQty"
                  class="w-8 h-8 rounded-full bg-white/10 text-white hover:bg-white/20 disabled:opacity-30 disabled:cursor-not-allowed transition-colors flex items-center justify-center">
                  <span class="material-symbols-outlined text-lg">add</span>
                </button>
              </div>
              <button
                type="button"
                data-testid="tab-points-item-all"
                (click)="setSelectedQty(item.productId, item.pointsEligibleQty)"
                class="text-xs text-amber-400/70 hover:text-amber-400 transition-colors">
                {{ 'pos.tabs.all' | translate }} ({{ item.pointsEligibleQty }})
              </button>
            </div>
          </div>
        } @empty {
          <div class="px-4 py-6 text-center text-white/50 text-sm">
            {{ 'pos.tabs.no_items_for_points' | translate }}
          </div>
        }
      </div>

      <div class="bg-amber-500/10 border border-amber-500/20 rounded-xl p-3">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-white/70">{{ 'pos.tabs.selected_total' | translate }}</span>
          <span
            class="text-xl font-bold text-amber-400"
            data-testid="tab-points-selected-total"
            >{{ selectedItemsPoints() }} b.</span
          >
        </div>
        <div class="flex items-center justify-between text-xs">
          <span class="text-white/50">{{ 'pos.tabs.available' | translate }}</span>
          <span
            class="font-semibold"
            [class.text-purple-400]="hasEnoughPointsForSelected()"
            [class.text-red-400]="!hasEnoughPointsForSelected()">
            {{ userPointBalance() }} b.
          </span>
        </div>
        @if (!hasEnoughPointsForSelected() && selectedItemsPoints() > 0) {
          <p class="text-xs text-red-400 mt-2 flex items-center gap-1">
            <span class="material-symbols-outlined text-sm">error</span>
            {{ 'pos.tabs.not_enough_points' | translate }}
          </p>
        }
      </div>
    </div>
  }

  <div class="flex justify-between">
    <k-button
      data-testid="tab-payment-cancel"
      [outlined]="true"
      [color]="ButtonColor.White"
      (click)="onCancel()">
      {{ 'admin.common.cancel' | translate }}
    </k-button>
    <k-button
      data-testid="tab-payment-confirm"
      [color]="ButtonColor.Green"
      [disabled]="!canSubmit()"
      [isLoading]="submitting()"
      [icon]="'check'"
      (click)="onSubmit()">
      {{ 'pos.tabs.confirm_payment' | translate }}
    </k-button>
  </div>
</div>
